import { useQueryUserLibraryFilterOptions } from '@ifit/gateway-wolf-athenaeum-service';
import {
  useMembershipTypeDisabler,
  useRequiredRequestOptions,
} from '../query-options';

export const useGetFilterOptions = () => {
  const {
    membershipType,
    softwareNumber,
    headers,
    useGatewayCache,
  } = useRequiredRequestOptions();
  return useQueryUserLibraryFilterOptions(
    {
      membershipType,
      softwareNumber,
      useGatewayCache,
      useBasicAuth: true,
      headers,
    },
    {
      ...useMembershipTypeDisabler(),
    },
  );
};
